// 图片(正式时需要换成备注的域名)
export const imageUrl = 'https://ossfastmake.mustke.com/'
export const adminUrl = 'https://makeadmin.xshangyun.com/' //正式
// export const adminUrl = 'https://makeadmin.qingsite.cn' //测试

// 测试
// export const SOCKET_AI_URL = 'wss://jlsockettest.jielong.vip/'  //测试
// 正式
export const SOCKET_AI_URL = 'wss://jlsocket.xshangyun.com/'  //正式
